(() => {
  // Desktop only
  const mq = window.matchMedia('(min-width: 990px)');
  if (!mq.matches) return;

  // Tweak these to taste
  const OPEN_DELAY = 220;   // ms before opening on hover
  const CLOSE_DELAY = 180;  // ms before closing after leaving

  // Target the Horizon menu items that have submenus
  const ITEM_SEL = 'li.menu-list__list-item';
  const LINK_SEL = 'a.menu-list__link[aria-controls^="submenu-"]';

  const timers = new WeakMap(); // element -> {openId, closeId}

  const getTimers = (el) => {
    if (!timers.has(el)) timers.set(el, { openId: null, closeId: null });
    return timers.get(el);
  };

  // Helper: dispatch pointer events to trigger Horizon's inline /activate /deactivate handlers
  const fire = (el, type) => {
    try {
      const evt = new PointerEvent(type, { bubbles: false, cancelable: true, pointerType: 'mouse' });
      el.dispatchEvent(evt);
    } catch {
      // fallback if PointerEvent isn't available
      el.dispatchEvent(new Event(type, { bubbles: false, cancelable: true }));
    }
  };

  // CAPTURE listeners to intercept the theme’s instant hover open
  document.addEventListener('pointerenter', (e) => {
    const li = e.target && e.target.closest ? e.target.closest(ITEM_SEL) : null;
    if (!li) return;

    const link = li.querySelector(LINK_SEL);
    if (!link) return; // no submenu, don't interfere

    // Stop the immediate open
    e.stopPropagation();

    const t = getTimers(li);
    if (t.closeId) clearTimeout(t.closeId);

    // Delay-open only if still hovered after OPEN_DELAY
    t.openId = setTimeout(() => {
      if (li.matches(':hover')) {
        fire(li, 'pointerenter'); // triggers Horizon activate
      }
    }, OPEN_DELAY);
  }, true);

  document.addEventListener('pointerleave', (e) => {
    const li = e.target && e.target.closest ? e.target.closest(ITEM_SEL) : null;
    if (!li) return;

    const link = li.querySelector(LINK_SEL);
    if (!link) return;

    // Stop the immediate close
    e.stopPropagation();

    const t = getTimers(li);
    if (t.openId) clearTimeout(t.openId);

    // Delay-close to prevent flicker when moving into the mega menu
    t.closeId = setTimeout(() => {
      fire(li, 'pointerleave'); // triggers Horizon deactivate
    }, CLOSE_DELAY);
  }, true);

  // Bonus: keep menu open while inside the submenu panel (prevents "fall off the edge" closes)
  document.addEventListener('pointerenter', (e) => {
    const submenu = e.target && e.target.closest ? e.target.closest('.menu-list__submenu') : null;
    if (!submenu) return;

    // Find the owning LI if possible and cancel pending closes
    const li = submenu.closest(ITEM_SEL);
    if (!li) return;
    const t = getTimers(li);
    if (t.closeId) clearTimeout(t.closeId);
  }, true);

})();
